<template>
  <CoreDrawer
    v-model="isActiveDrawer"
    data-qa="laboratories-list-modal"
    :title="isShowEmptyState ? '' : 'Выберите лабораторию'"
    @input="handleInput"
  >
    <template
      v-if="!isShowEmptyState"
      #header
    >
      <LaboratoriesListSearch />
    </template>

    <div
      v-if="isShowEmptyState"
      class="d-flex flex-column justify-center fill-height px-4"
      data-qa="laboratories-empty-state"
    >
      <v-img
        width="175"
        min-height="175"
        max-height="175"
        src="/static/_v1/pd/pictures/stubs/empty-cart.png"
        class="mx-auto mb-4"
      />
      <div class="text-h6 text--text mb-2 text-center">
        Нет лабораторий, где можно сдать все анализы из корзины
      </div>
      <div class="text-body-1 text-secondary--text text-center">
        Попробуйте убрать некоторые анализы
      </div>
    </div>
    <LaboratoriesListSkeletons
      v-else-if="isWithoutRequests"
      class="px-2"
    />
    <LaboratoriesListLabs
      v-else
      x-space-class="px-4"
      @click:lab="emit('click:lab', $event)"
    />
  </CoreDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import CoreDrawer from 'src/core/CoreDrawer/CoreDrawer.vue'
import { Laboratory } from 'www/vue_components/common/Analyses/types'
import useLabsStore from 'www/vue_components/common/Analyses/components/LaboratoriesList/stores/useLabsStore'
import LaboratoriesListSearch from 'www/vue_components/common/Analyses/components/LaboratoriesList/components/LaboratoriesListSearch.vue'
import LaboratoriesListSkeletons from 'www/vue_components/common/Analyses/components/LaboratoriesList/components/LaboratoriesListSkeletons.vue'
import LaboratoriesListLabs from 'www/vue_components/common/Analyses/components/LaboratoriesList/components/LaboratoriesListLabs.vue'

type Emits = {
  (_e: 'click:lab', _: { id: number, lpu: Laboratory }): void
}

const emit = defineEmits<Emits>()

const labsStore = useLabsStore()
const { requestLabData, hideDrawer } = labsStore
const {
  isActiveDrawer,
  laboratoryList,
  isRequesting,
  isWithoutRequests,
} = storeToRefs(labsStore)

const isShowEmptyState = computed(() => (
  !laboratoryList.value.length && !isRequesting.value && !requestLabData.searchString.length
))

function handleInput(value: boolean) {
  if (!value) {
    hideDrawer()
  }
}
</script>
